import React from "react";
import { Box, Typography } from "@mui/material";
import rockets from "../../../../assets/rocket-image.png";
import rocketline from "../../../../assets/rocket-line.png";
import Header from "../componets/Header";
import Footer from "../componets/Footer";
import about from "../../../../assets/abut.png";

const steps = [
  {
    id: 1,
    title: "GREETING TIME",
    description:
      "A morning greeting can set the tone for the entire day. At PODAR PREP, we follow a greeting ritual where children get to choose from a variety of greeting methods while entering the class. This helps children to feel safe, secure, and welcomed that supports them to start their day on a positive note.",
  },
  {
    id: 2,
    title: "DAILY 5",
    description:
      "DAILY 5 activity is done every day where the teacher and children discuss the weather, day, and date for the day. A daily morning routine helps children and the teacher get to know each other, gets them connected and creates a positive classroom environment.",
  },
  {
    id: 3,
    title: "PLAY-EXPLORE-LEARN",
    description:
      "This is a free play time for children where 3 corners are set for children to explore various toys and play based learning materials that are focused around different areas of development integrated with Coding and S.T.R.E.A.M. Children get to choose, explore, play, and learn while developing their social skills.",
  },
  {
    id: 4,
    title: "CIRCLE TIME",
    description:
      "Circle Time is an activity that develops friendly relationships amongst the children and builds on their communication and language skills. Circle time includes singing rhymes and a whole class discussion.",
  },
  {
    id: 5,
    title: "LITERACY AND NUMERACY TIME",
    description:
      "The teacher introduces either letters or numbers at a time in a story form using puppets, teaching aids, voice modulation, and facial expressions to ensure effective teaching-learning process. This is followed by hands on activities to reinforce the concepts using various resources.",
  },
  {
    id: 6,
    title: "SNACK TIME",
    description:
      "A time where children learn the importance of eating healthy food, communication, sharing,  and time management in completing their snacks.",
  },
  {
    id: 7,
    title: "TRANSITIONS",
    description:
      "Transitions are ‘brain breaks’ used by the teacher with the children in between two activities. It supports children to transit to the next activity with ease.",
  },
  {
    id: 8,
    title: "UNDERSTANDING MY WORLD",
    description:
      "Understanding My World is a time for children to learn about various concepts that are introduced through a story. Teacher will ask open ended questions to know the prior knowledge of children using different teaching strategies in a fun interactive manner using various teaching aids such picture talks, flash cards,  etc. This is then followed by hands on activities encompassing the S.T.R.E.A.M and CODING aspects to make learning more application based, meaningful, and fun for children.",
  },
  {
    id: 9,
    title: "ACTIVE EXPLORATION",
    description:
      "Outdoor and physical play are great activities for the child’s gross motor development. Thus, the teacher will be taking children in the outdoor for games and activities planned and given in the curriculum.",
  },
  {
    id: 10,
    title: "BYE-BYE TIME / REVERENCE",
    description:
      "Reverence enables the children to encapsulate and remember all the learning and hands -on exploration done during the day. Children recall the activities done during the day and express what they liked the most.",
  },
];

const headerHeight = 90;

const DayAtPodarPrep = () => {
  return (
    <>
      <Box
        component="header"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: `${headerHeight}px`,
          zIndex: 1000,
          bgcolor: "background.paper",
          boxShadow: 1,
        }}
      >
        <Header />
      </Box>

      <Box
        sx={{
          pt: `${headerHeight + 20}px`,
          pb: 10,
          maxWidth: "1000px",
          mx: "auto",
          mt: 20,
          position: "relative",
          minHeight: "100vh",
          backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${about})`,
        }}
      >
        {/* Rocket Image */}
        <Box
          component="img"
          src={rockets}
          alt="Rocket"
          sx={{
            width: 150,
            height: 250,
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 120,
            left: "50%",
            transform: "translateX(-50%)",
            height: `calc(100% - 120px)`,
            width: 47, // thicker line width
            backgroundImage: `url(${rocketline})`,
            backgroundRepeat: "repeat-y",
            backgroundSize: " 50px 50px", // bigger dots and spacing
            zIndex: 1,
          }}
        />

        {/* Steps */}
        <Box sx={{ mt: 30 }}>
          {steps.map((step, index) => {
            const isLeft = index % 2 === 0;

            return (
              <Box
                key={step.id}
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "center",
                    md: isLeft ? "flex-start" : "flex-end",
                  },
                  position: "relative",
                  mb: 8,
                }}
              >
                {/* Content Box */}
                <Box
                  sx={{
                    width: { xs: "90%", md: "45%" },
                    textAlign: isLeft ? "right" : "left",
                    position: "relative",
                  }}
                  
                >
                  {/* Step Title & Description */}
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#4a70af", mb: 1 }}
                  >
                    {step.title}
                  </Typography>
                  <Typography sx={{ fontSize: "16px", color: "#444" }}>
                    {step.description}
                  </Typography>
                </Box>

                {/* Circle on Line */}
                <Box
                  sx={{
                    position: "absolute",
                    top: "0",
                    left: "50%",
                    transform: "translate(-50%, -30%)",
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    backgroundColor: isLeft ? "#24488e" : "#f7c744",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 40,
                    lineHeight: "60px",
                    textAlign: "center",
                    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                    border: "4px solid white",
                    zIndex: 5,
                  }}
                >
                  {step.id}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      <Footer />
    </>
  );
};

export default DayAtPodarPrep;

